import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Layout from './components/Layout';
import ProductIntro from './pages/LaunchCool/ProductIntro';
import ProductList from './pages/ProductList';
import Post from './pages/Post';
import CreatePost from './pages/CreatePost';
import Account from './pages/Account';
import AccountSelf from './pages/AccountSelf';
import Login from './pages/Login';
import ProtectedRoute from './utils/ProtectedRoute';
import AuthProvider from "./store/AuthProvider";
import MarkdownTest from './components/Post/MarkdownTest';
import MarkdownTestInput from './components/Post/MarkdownTestInput';
import MarkdownUpdate from './components/Post/MarkdownUpdate';
import ChatGPTSaverPrivacy from './pages/ChatGPTSaver/Privacy';
import Home from './pages/Home';
import HomeV2 from './pages/HomeV2';
import HomeV3 from './pages/HomeV3';
import HomeV4 from './pages/HomeV4';
import HomeV5 from './pages/HomeV5';
import AIMeetingPro from './pages/AIMeetingPro';
import AIMeetingProDownload from './pages/AIMeetingPro/Download/AIMeetingProDownload';
import AIMeetingProPost from './pages/AIMeetingPro/AIMeetingProPost';

function App() {
  const hostname = window.location.hostname;
  const subdomain = hostname.split('.')[0];

  let routes;

  if (subdomain === 'stemcellsoft' || subdomain === 'www' || subdomain === 'localhost') {
   
    routes = (
      <Layout>
        <Routes>
          <Route path="/" element={<ProductList />} />
          <Route path="/v2" element={<HomeV2 />} />
          <Route path="/v3" element={<HomeV3 />} />
          <Route path="/v4" element={<HomeV4 />} />
          <Route path="/v5" element={<HomeV5 />} />
          <Route path="/a" element={<Account />} />
        </Routes>
      </Layout>
    );
  } else if (subdomain === 'aimeetingpro') {
    routes = (
      <Routes>
        <Route path="/" element={<AIMeetingPro />} />
        <Route path="/download" element={<AIMeetingProDownload />} />
        <Route path="/p" element={<AIMeetingProPost />} />
      </Routes>
    );
  } else if (subdomain === 'chatgptsaver') {
    routes = (
      <Routes>
        <Route path="/" element={<ChatGPTSaverPrivacy />} />
      </Routes>
    );
  } else if (subdomain === 'blog') {
    routes = (
      <Layout>
        <Routes>
        <Route path="/a" element={<Account />} />
        <Route path="/p" element={<Post />} />
        <Route path="/" element={<Post />} />
        <Route path="/m" element={<MarkdownTest />} />
        <Route path="/mi" element={
            <ProtectedRoute>
               <MarkdownTestInput />
             </ProtectedRoute>
          } />
          <Route path="/mu" element={
            <ProtectedRoute>
              <MarkdownUpdate />
            </ProtectedRoute>
          } />
          <Route path="/cp" element={
            <ProtectedRoute>
              <CreatePost />
             </ProtectedRoute>
          } />
          <Route path="/jlIf1" element={
            <AuthProvider>
              <Login />
            </AuthProvider>
            } />
          <Route path="/as" element={
            <ProtectedRoute>
              <AccountSelf />
           </ProtectedRoute>
            } />
        </Routes>
      </Layout>
    );
  }

  return <Router>{routes}</Router>;
}

export default App;
